import { render, staticRenderFns } from "./CalculoComplemento.vue?vue&type=template&id=cc773538&scoped=true&"
import script from "./CalculoComplemento.vue?vue&type=script&lang=js&"
export * from "./CalculoComplemento.vue?vue&type=script&lang=js&"
import style0 from "./CalculoComplemento.vue?vue&type=style&index=0&id=cc773538&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc773538",
  null
  
)

export default component.exports